export const SUPPORTED_LANGUAGE_CODES = Object.freeze(['en', 'fr']);
export const DEFAULT_LANGUAGE_CODE = 'en';

export const normalizeLanguageCode = value => {
  if (typeof value !== 'string') return DEFAULT_LANGUAGE_CODE;

  const languageCode = value.trim().toLowerCase().split(/[-_]/)[0];

  return SUPPORTED_LANGUAGE_CODES.includes(languageCode) ? languageCode : DEFAULT_LANGUAGE_CODE;
};
